export function transformOffer(offer) {
    return Object.assign(Object.assign({}, offer), { offer_type_id: `${offer.offer_type_id}`, description: `${offer.description} `, is_paid: offer.is_paid === 1 ? 'true' : 'false', is_active: offer.is_active === 1 });
}
